import { ref } from 'vue'

export const useResubmissionHelper = () => {
	const errorMessage = ref<string>()

	const setError = (e: any) => {
		errorMessage.value =
			'We were unable to process the submission for the following reason: '
		errorMessage.value += e instanceof Error ? e.message : String(e)
	}

	return {
		errorMessage,
		setError,
	}
}

export default useResubmissionHelper
